import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { Link } from 'react-router-dom'
import SydLinkButton from '../../../../commonDesign/LinkButton'
import Card from '../../../../molecules/Card'
import { useGetIntegrationTableMetadata } from '../../../../../api/integrations'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import { targetManagedNoteStyle } from './shared'

function JobTableInfo ({ jobConfigurationId, assignedTarget }) {
  const { data } = useGetIntegrationTableMetadata(jobConfigurationId)

  if (!data?.tableSchema) return null

  return (
    <Grid item xs={12}>
      <FadeIn>
        <Card>
          <h3>Table Info: {data?.tableSchema?.tableName}</h3>
          {assignedTarget && (
            <div style={targetManagedNoteStyle}>
              Table schema is managed by the provisioned target{' '}
              <Link to={`/admin/denali/integrator/targets/${assignedTarget.provisionedTargetTableId}`}>
                {assignedTarget.tableName}
              </Link>. Migrations run against the target definition.
            </div>
          )}
          <div>
            <SydLinkButton variant='primary' to={`/admin/denali/integrator/jobs/${jobConfigurationId}/query`} icon='search'>Query</SydLinkButton>
          </div>
        </Card>
      </FadeIn>
    </Grid>
  )
}

JobTableInfo.propTypes = {
  jobConfigurationId: PropTypes.number,
  assignedTarget: PropTypes.object
}

export default JobTableInfo
